import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCurrentUser, useAccessToken } from '@/features/auth/state/auth'
import api from '@/lib/api'
import { InfoUser, RegimeProduto } from '@/types/user'
import { RemovaCharEspeciais } from '@/utils/format'

interface CreateUsuarioParams {
  info_user: InfoUser
  Regime_produto: RegimeProduto
}

export function useCreateUsuario() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ info_user, Regime_produto }: CreateUsuarioParams) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const body = {
        name: info_user.name,
        password: info_user.password,
        cpf: info_user.cpf,
        email: info_user.email,
        whatsApp: info_user.whatsApp,
        tel: info_user.tel ? `${info_user.tel}` : null,
        typeCargo: info_user.typeCargo,
        cnpj: info_user.cnpj || null,
        razao_social: info_user.razao_social || null,
        cnae: info_user.cnae || null,
        atividadePrincipal: info_user.atividadePrincipal || null,
        comissao_user: Number(Regime_produto.comissao) || 0,
        comissao_user_escrita: Regime_produto.comissao_escrita || '0',
        cep: RemovaCharEspeciais(info_user.cep || '') || null,
        logradouro: info_user.logradouro || null,
        bairro: info_user.bairro || null,
        numero: info_user.numero || null,
        municipio: info_user.municipio || null,
        estado: info_user.estado || null,
        complemento: info_user.complemento || null
      }

      const response = await api.post(`/user/create-user`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) return response.data
      throw new Error('Erro ao criar usuário')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] })
    }
  })
}
